/* Copyright 2016 Mozilla Foundation
 *
 *   , Version 2.0 (the "License");
 *     
 *      
 *
 *           
 *
 *  
 * distributed under the License is distributed on an "AS IS" BASIS,
 *  
 *  
 *  
 */
/* globals module */

"use strict";

module.exports = globalThis.pdfjsLib;
